'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var mkdir = require('./mkdir.js');

var stat = require('./stat.js');

var debug = require('debug');

var errCode = require('err-code');

var updateTree = require('./utils/update-tree.js');

var updateMfsRoot = require('./utils/update-mfs-root.js');

var addLink = require('./utils/add-link.js');

var toMfsPath = require('./utils/to-mfs-path.js');

var mergeOpts = require('merge-options');

var toTrail = require('./utils/to-trail.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = debug__default["default"]('ipfs:mfs:cp');
var defaultOptions = {
  parents: false,
  flush: true,
  hashAlg: 'sha2-256',
  cidVersion: 0,
  shardSplitThreshold: 1000
};

function createCp(context) {
  function mfsCp(_x, _x2) {
    return _mfsCp.apply(this, arguments);
  }

  function _mfsCp() {
    _mfsCp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(from, to) {
      var opts,
          options,
          sources,
          destination,
          missing,
          destinationIsDirectory,
          parentFolder,
          destinationPath,
          trail,
          source,
          destinationName,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              options = mergeOptions(defaultOptions, opts);

              if (!Array.isArray(from)) {
                from = [from];
              }

              _context.next = 5;
              return Promise.all(from.map(function (path) {
                return toMfsPath.toMfsPath(context, path, options);
              }));

            case 5:
              sources = _context.sent;
              _context.next = 8;
              return toMfsPath.toMfsPath(context, to, options);

            case 8:
              destination = _context.sent;

              if (!(!sources.length || !destination)) {
                _context.next = 11;
                break;
              }

              throw errCode__default["default"](new Error('Please supply at least one source'), 'ERR_INVALID_PARAMS');

            case 11:
              missing = sources.find(function (source) {
                return !source.exists;
              });

              if (!missing) {
                _context.next = 14;
                break;
              }

              throw errCode__default["default"](new Error("".concat(missing.path, " does not exist")), 'ERR_INVALID_PARAMS');

            case 14:
              destinationIsDirectory = isDirectory(destination);

              if (!destination.exists) {
                _context.next = 21;
                break;
              }

              log('Destination exists');

              if (!(sources.length === 1 && !destinationIsDirectory)) {
                _context.next = 19;
                break;
              }

              throw errCode__default["default"](new Error('directory already has entry by that name'), 'ERR_ALREADY_EXISTS');

            case 19:
              _context.next = 50;
              break;

            case 21:
              log('Destination does not exist');

              if (!(sources.length > 1)) {
                _context.next = 32;
                break;
              }

              if (options.parents) {
                _context.next = 25;
                break;
              }

              throw errCode__default["default"](new Error('destination did not exist, pass -p to create intermediate directories'), 'ERR_INVALID_PARAMS');

            case 25:
              _context.next = 27;
              return mkdir.createMkdir(context)(destination.path, options);

            case 27:
              _context.next = 29;
              return toMfsPath.toMfsPath(context, destination.path, options);

            case 29:
              destination = _context.sent;
              _context.next = 50;
              break;

            case 32:
              if (!(destination.parts.length > 1)) {
                _context.next = 50;
                break;
              }

              parentFolder = "/".concat(destination.parts.slice(0, -1).join('/'));
              _context.prev = 34;
              _context.next = 37;
              return stat.createStat(context)(parentFolder, options);

            case 37:
              _context.next = 50;
              break;

            case 39:
              _context.prev = 39;
              _context.t0 = _context["catch"](34);

              if (!(_context.t0.code !== 'ERR_NOT_FOUND')) {
                _context.next = 43;
                break;
              }

              throw _context.t0;

            case 43:
              if (options.parents) {
                _context.next = 45;
                break;
              }

              throw errCode__default["default"](new Error('destination did not exist, pass -p to create intermediate directories'), 'ERR_INVALID_PARAMS');

            case 45:
              _context.next = 47;
              return mkdir.createMkdir(context)(parentFolder, options);

            case 47:
              _context.next = 49;
              return toMfsPath.toMfsPath(context, destination.path, options);

            case 49:
              destination = _context.sent;

            case 50:
              destinationPath = isDirectory(destination) ? destination.mfsPath : destination.mfsDirectory;
              _context.next = 53;
              return toTrail.toTrail(context, destinationPath);

            case 53:
              trail = _context.sent;

              if (!(sources.length === 1)) {
                _context.next = 61;
                break;
              }

              source = sources.pop();

              if (source) {
                _context.next = 58;
                break;
              }

              throw errCode__default["default"](new Error('could not find source'), 'ERR_INVALID_PARAMS');

            case 58:
              destinationName = destinationIsDirectory ? source.name : destination.name;
              log("Only one source, copying to destination ".concat(destinationIsDirectory ? 'directory' : 'file', " ").concat(destinationName));
              return _context.abrupt("return", copyToFile(context, source, destinationName, trail, options));

            case 61:
              log('Multiple sources, wrapping in a directory');
              return _context.abrupt("return", copyToDirectory(context, sources, destination, trail, options));

            case 63:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[34, 39]]);
    }));
    return _mfsCp.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(mfsCp);
}

var isDirectory = function isDirectory(destination) {
  return destination.unixfs && destination.unixfs.type && destination.unixfs.type.includes('directory');
};

var copyToFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, source, destination, destinationTrail, options) {
    var parent, newRootCid;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            parent = destinationTrail.pop();

            if (parent) {
              _context2.next = 3;
              break;
            }

            throw errCode__default["default"](new Error('destination had no parent'), 'ERR_INVALID_PARAMS');

          case 3:
            _context2.next = 5;
            return addSourceToParent(context, source, destination, parent, options);

          case 5:
            parent = _context2.sent;
            destinationTrail.push(parent);
            _context2.next = 9;
            return updateTree.updateTree(context, destinationTrail, options);

          case 9:
            newRootCid = _context2.sent;
            _context2.next = 12;
            return updateMfsRoot.updateMfsRoot(context, newRootCid, options);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function copyToFile(_x3, _x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();

var copyToDirectory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, sources, destination, destinationTrail, options) {
    var i, source, newRootCid;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < sources.length)) {
              _context3.next = 9;
              break;
            }

            source = sources[i];
            _context3.next = 5;
            return addSourceToParent(context, source, source.name, destination, options);

          case 5:
            destination = _context3.sent;

          case 6:
            i++;
            _context3.next = 1;
            break;

          case 9:
            destinationTrail[destinationTrail.length - 1] = destination;
            _context3.next = 12;
            return updateTree.updateTree(context, destinationTrail, options);

          case 12:
            newRootCid = _context3.sent;
            _context3.next = 15;
            return updateMfsRoot.updateMfsRoot(context, newRootCid, options);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function copyToDirectory(_x8, _x9, _x10, _x11, _x12) {
    return _ref2.apply(this, arguments);
  };
}();

var addSourceToParent = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, source, childName, parent, options) {
    var sourceBlock, _yield$addLink$addLin, node, cid, size;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return context.repo.blocks.get(source.cid);

          case 2:
            sourceBlock = _context4.sent;
            _context4.next = 5;
            return addLink.addLink(context, {
              parentCid: parent.cid,
              size: sourceBlock.length,
              cid: source.cid,
              name: childName,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion,
              flush: options.flush,
              shardSplitThreshold: options.shardSplitThreshold
            });

          case 5:
            _yield$addLink$addLin = _context4.sent;
            node = _yield$addLink$addLin.node;
            cid = _yield$addLink$addLin.cid;
            size = _yield$addLink$addLin.size;
            parent.node = node;
            parent.cid = cid;
            parent.size = size;
            return _context4.abrupt("return", parent);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function addSourceToParent(_x13, _x14, _x15, _x16, _x17) {
    return _ref3.apply(this, arguments);
  };
}();

exports.createCp = createCp;